<template>
  <div class="nothingness-activity-wrapper">
    <NoWorksData noDataText="活动不存在" />
  </div>
</template>

<script>
import NoWorksData from '@/components/NoWorksData'

export default {
  name: 'nothingnessActivity',
  components: {
    NoWorksData
  }
}
</script>

<style lang="scss" scoped>
.nothingness-activity-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 3rem;
}
</style>
